import type { FaireProductEntity } from "../../entity_types/product";

export const p_eut5t2p3tv: FaireProductEntity = {
  token: "p_eut5t2p3tv",
  type: "product",
  name: "Pastel Rainbow Birthday Girl Headband - Birthday Headband",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/1bd625b72733635e12ee5f1c9afb77f2415be74c7d40d0469fec2343197f5de8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cb199ebd367e2aef8b2c4b3369aab92c7741b0649631d3d53aa7fdc5ab88928c.jpeg",
    "https://cdn.faire.com/fastly/012c497585c5911575b8bf2d92400432d6697a7e90602ce807e46c9556ffd41b.jpeg",
    "https://cdn.faire.com/fastly/e6a3b7f00528c39ae1fd1dc5a21ee9a6c22f7f0375394fc9d1aa312c24f33001.jpeg",
    "https://cdn.faire.com/fastly/cc20704ca9ba5e030d273d4e0042363304caac8a45b92d95aa2f9ba17da5343c.jpeg",
    "https://cdn.faire.com/fastly/20b7d6a28246bc7946319bc28d686d6bf944421b131c61c6339557452afb2bb8.jpeg",
    "https://cdn.faire.com/fastly/f10ee810738446e8ec8459e7ecaa3f9927582cc92ad59d98fe89ccfaf9867c3c.jpeg",
  ],
  priceDollars: 7,
  description:
    'Every little girl needs the perfect headband to complete her look! The Pastel Rainbow Birthday Girl Headband is the perfect hair accessory for celebrating a Birthday.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n• Pastel rainbow glitter "Birthday Girl" letters arching the top of the headband\n• Satin lined headband\n• Glitter accents are “shed free”\n• One size fits all\n\nDue to the ombre effect of the glitter, each headband will be slightly unique in color.\n\nPair this headband with a matching Sweet Wink tutu and shirt for a complete head-to-toe outfit!',
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:44:20.973Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
